import axios from "axios";
import ApiConstants from "../Utils/ApiConstant";
import SessionManager from "../Utils/Session";

const FaqCategoryService = {
  // Existing login function
  getFaqCategorys: async (offset, limit, searchQuery) => {
    try {
      const response = await axios.get(
        ApiConstants.getFaqCategorys +
          `?offset=${offset}&limit=${limit}&searchQuery=${searchQuery.trim()}`,
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  getAllFaqCategoryWithoutPagination: async () => {
    try {
      const response = await axios.get(
        ApiConstants.getAllFaqCategoryWithoutPagination,
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },
  addCategory: async (id, faqCategoryName) => {
    try {
      const response = await axios.post(
        ApiConstants.addFaqCategory,
        {
          faq_category_id: id,
          faqCategoryName: faqCategoryName.trim(),
        },
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  updateFaqCategroyStatus: async (id, status) => {
    try {
      const response = await axios.put(
        ApiConstants.changeStatusFaqCategorys,
        {
          id: id,
          is_active: status,
        },
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );

      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },
  editBlog: async ({ id, categoryName }) => {
    try {
      const response = await axios.post(
        ApiConstants.addBlogCategory,
        { blog_category_id: id, categoryName: categoryName.trim() },
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  deleteFaqCategory: async (id) => {
    try {
      const response = await axios.post(
        ApiConstants.deleteFaqCategorys,
        {
          id: id,
        },
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  //Faq services...
  addFaq: async (faq_id, faq_category_id, question, answer) => {
    try {
      const response = await axios.post(
        ApiConstants.addFaq,
        {
          faq_id: faq_id,
          faq_category_id: faq_category_id,
          question: question,
          answer: answer,
        },
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },
  getFaq: async (offset, limit, searchQuery) => {
    try {
      const response = await axios.get(
        ApiConstants.getFaq +
          `?offset=${offset}&limit=${limit}&searchQuery=${searchQuery.trim()}`,
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },
  updateFaqStatus: async (id, status) => {
    try {
      const response = await axios.put(
        ApiConstants.changeStatusFaq,
        {
          id: id,
          is_active: status,
        },
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );

      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },
  deleteFaq: async (id) => {
    try {
      const response = await axios.post(
        ApiConstants.deleteFaq,
        {
          id: id,
        },
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },
};

export default FaqCategoryService;
